module.exports = __webpack_public_path__ + "static/VSTT-3191252e3c85e218f7d65534c195cee1.svg";